export default __webpack_public_path__ + "static/media/t2.6ea5eb28.png";